import React from 'react';
import Button from '~/Common-Objects/UI/Forms/Button/Button'

export default class AbTestDelete extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    render() {
        return <div>
            <h4 className="mar-b25">
                Delete Test
            </h4>
            <div className="mar-b25">
                Are you sure you want to delete this test?
            </div>
            <Button text="Delete it" onClick={() => { this.props.deleteCampaign() }} />
        </div>
    }
}
